<ng-container *ngIf="value !== undefined">
  <div class="headline">{{ value.headline }}</div>
  <div class="text" [innerHTML]="formattedValue"></div>
</ng-container>
